if (!customElements.get('brand-motion')) {
  customElements.define('brand-motion', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      if (!this.querySelector("img") || !this.dataset.animation) return;
      this.ready = true;
      this.image = this.querySelector('img');
      this.poster = this.image.src;
      this.preference = matchMedia('(prefers-reduced-motion: reduce)');
      this.controller = new AbortController();
      this.preference.addEventListener('change', () => {
        if (this.preference.matches) this.setPlaying(false);
        else if (this.getBoundingClientRect().top < innerHeight && this.getBoundingClientRect().bottom > 0) this.setPlaying(true);
      }, { signal: this.controller.signal });
      this.observer = new IntersectionObserver(entries => {
        if (entries[0].isIntersecting && !this.preference.matches) this.setPlaying(true);
        if (!entries[0].isIntersecting) this.setPlaying(false);
      }, { rootMargin: '100px' });
      this.observer.observe(this);
    }
    setPlaying(value) {
      if (this.playing === value) return;
      this.playing = value;
      this.image.src = value ? this.dataset.animation : this.poster;
    }
    disconnectedCallback() {
      this.observer?.disconnect();
      this.controller?.abort();
      this.setPlaying(false);
      this.ready = false;
    }
  });
}
